import { db } from "@/firebase/firebaseInit";
import { collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, serverTimestamp, setDoc, updateDoc, where } from "firebase/firestore";

let unsubscribe;
let unsubscribeVolunteersList;

export default {
    async signUpVolunteer(context, payload) {
        await Promise.all([
            setDoc(doc(db, "fds/" + payload.fdID + "/volunteers/" + payload.userID), {
                name: payload.name,
                role: payload.role,
                location: payload.location,
                with_helper: payload.withHelper,
                can_be_helper: payload.canBeHelper,
                timestamp: serverTimestamp(),
                team: payload.location === 'TBR' ? 'void_deck' : "",
                volunteer_type: payload.volunteerType
            }),
            updateDoc(doc(db, "fds/" + payload.fdID), payload.countUpdate)
        ]);
    },
    async loadVolunteerData(context, payload) {
        console.log("Looking for Volunteer data for FD: " + payload.fdID + " and userID: " + payload.userID)
        if (unsubscribe) unsubscribe();
        context.commit('resetVolunteerDataResolved');
        unsubscribe = onSnapshot(doc(db, "fds/" + payload.fdID + "/volunteers", String(payload.userID)),
            (doc) => {
                context.commit('setVolunteerData', doc.data());
            },
            (error) => {
                console.log("ERROR occurred! " + error.message);
            });
    },

    // Unsubscribe volunteer data when the component is unmounted
    unsubscribeVolunteer() {
        unsubscribe();
    },

    async loadTeamMembers(context, payload) {
        console.log("Loading members of team: " + payload.team + " for FD: " + payload.fdID);
        const q = query(collection(db, "fds/" + payload.fdID + "/volunteers"), where("team", "==", payload.team));
        const querySnapshot = await getDocs(q);
        const members = [];
        querySnapshot.forEach((doc) => {
            members.push(doc.data());
        });
        context.commit("setTeamMembers", members);
    },

    subscribeVolunteers(context, payload) {
        const q = query(collection(db, "fds/" + payload + "/volunteers"), orderBy("role"), orderBy("team"), orderBy("timestamp"));
        unsubscribeVolunteersList = onSnapshot(q, (querySnapshot) => {
            const volunteers = [];
            querySnapshot.forEach((doc) => {
                const volunteer = doc.data();
                volunteer.id = doc.id;
                volunteers.push(volunteer);
            });
            context.commit("setVolunteers", volunteers);
        });
    },

    unsubscribeVolunteers() {
        if (unsubscribeVolunteersList) {
            unsubscribeVolunteersList();
        }
    },

    async updateTeams(context, payload) {
        for (const volunteer of payload.volunteers) {
            await updateDoc(doc(db, "fds/" + payload.fdID + "/volunteers/" + volunteer.id), {
                team: volunteer.team
            });
        }
    },

    async getUserRegistration(context, { fdID, userID }) {
        const snap = await getDoc(doc(db, `fds/${fdID}/volunteers/${userID}`));
        return snap.exists() ? snap.data() : null;
    },

    async removeVolunteerSignUp(context, payload) {
        console.log("Removing volunteer '" + payload.volunteerID + "' from sign-up of FD '" + payload.fdID + "'");
        await deleteDoc(doc(db, "fds/" + payload.fdID + "/volunteers", payload.volunteerID))
    },

    async changeVolunteerLocation(context, { fdID, volunteerID, currentLocation }) {
        const newLocation = currentLocation === 'TBR' ? 'REDHILL' : 'TBR';
        await updateDoc(doc(db, `fds/${fdID}/volunteers/${volunteerID}`), {
            location: newLocation,
            team: newLocation === 'TBR' ? 'void_deck' : '',
            role: 'OTHER',
        });
    }
}